import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetPassword, clearErrorCode, resetPassSecretKey, logout } from '../../core/actions/authAction';
import { Button, Form, Grid, Header, Image } from 'semantic-ui-react';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import logoUrl from '../../assets/images/logo.png';
import functionCommon from "../../core/common/function";

let isCheckSecretKey = false;
class ResetPassword extends Component {
	constructor() {
		super();
		this.state = {
			password: '',
			passwordMsg: '',
			confirm: '',
			confirmMsg: '',
			submitted: '',
			errorMessageText: '',
			btnDisable: false
		}
	}

	// Call API check Secrect key before load page
	componentWillMount() {
		const code = functionCommon.getCurrentPath(this.props.router.location.pathname, '/reset-password/:code');
		this.props.resetPassSecretKey({ 'resetPassSecretKey': code });
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ btnDisable: false });
		if (nextProps.authReducer.errorCode === "secretKey") {
			window.location = '/error/404';
		} else {
			isCheckSecretKey = true;
		}
		if (nextProps.authReducer.errorCode) {
			this.setState({ errorMessageText: "message." + nextProps.authReducer.errorCode });
		}
		if (nextProps.authReducer.successCode) {
			this.props.logout();
		}
	}

	errorMessage = (message) => {
		const { t } = this.props;
		return (
			<div className="error-message">
				{t(message)}
			</div>
		)
	}

	handleChange = (e, { name, value }) => {
		this.props.clearErrorCode();
		this.setState({ [name]: value });
		this.setState({ errorMessageText: '' });
		this.setState({passwordMsg: '' });
		this.setState({confirmMsg: '' });
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({ submitted: true });
		const { password, confirm } = this.state;
		const code = functionCommon.getCurrentPath(this.props.router.location.pathname, '/reset-password/:code');
		const isValidatePassword  = functionCommon.validatePassword(password);

		// Check validate password field
		if (password) {
			if (!isValidatePassword) {
				this.setState({ passwordMsg: 'message.015' });
			}
		}
		
		if (password && confirm && isValidatePassword) {
			if (password === confirm) {
				this.setState({ btnDisable: true });
				this.props.resetPassword({ 'resetPassSecretKey': code, 'newPassword': password });
			} else {
				this.setState({ confirmMsg: 'message.007' });
			}
		}
	}

	render() {
		const { t } = this.props;
		const { password, confirm, submitted, errorMessageText, btnDisable, passwordMsg, confirmMsg } = this.state;
		// When secret password key true
		if (isCheckSecretKey) {
			return (
				<Grid textAlign='center' verticalAlign='middle' className="account-wrapper">
					<div className="account-container">
						<Grid.Column className="p-0">
							<Header textAlign='left' className="account-form-header">
								<Image src={logoUrl} className="account-form-logo" />
								<h2 className="account-form-title">{t("account.resetPassword")}</h2>
							</Header>
							<Form size='large' onSubmit={this.handleSubmit} error>
								{errorMessageText ? this.errorMessage(errorMessageText) : ''}
								<Form.Input
									fluid
									icon='lock'
									iconPosition='left'
									placeholder={t("account.enterNewPassword")}
									type='password'
									name='password'
									onChange={this.handleChange}
								/>
								{submitted && !password && 
									<div className="error-message">
										{t("message.005")}
									</div>
								}
								{submitted && passwordMsg && 
									<div className="error-message">
										{t(passwordMsg)}

									</div>
								}								
								<Form.Input
									fluid
									icon='lock'
									iconPosition='left'
									placeholder={t("account.confirmNewPassword")}
									type='password'
									name='confirm'
									onChange={this.handleChange}
								/>
								{submitted && !confirm &&
									<div className="error-message">
										{t("message.006")}
									</div>
								}
								{submitted && confirmMsg &&
									<div className="error-message">
										{t(confirmMsg)}
									</div>
								}
								<Button disabled={btnDisable} fluid size='large' className="account-form-btn">
									{t("account.saveNewPassword")}
								</Button>
							</Form>
						</Grid.Column>
					</div>
				</Grid>
			)
		} else {
			return (
				<div>
					<Grid textAlign='center' verticalAlign='middle' className="account-wrapper"></Grid>
				</div>
			)
		}
	}
}

const mapStateToProps = state => ({
	...state
})

const mapDispatchToProps = dispatch => ({
	resetPassword: (data) => dispatch(resetPassword(data)),
	logout: () => dispatch(logout()),
	clearErrorCode: () => dispatch(clearErrorCode()),
	resetPassSecretKey: (data) => dispatch(resetPassSecretKey(data))
})

export default compose(
	withTranslation(),
	connect(mapStateToProps, mapDispatchToProps)
)(ResetPassword);
